function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PostTeaserTemplate = require('./post-teaser.template');

/**
 * PostTeaser UI Component
 *
 * Root namespace: .post-teaser
 * options.compact — denser layout when parent arranges teaser in a tight slot
 */
var PostTeaser = /*#__PURE__*/function () {
  function PostTeaser(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var transaction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    _classCallCheck(this, PostTeaser);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.transaction = transaction;
    this.options = options || {};
  }
  return _createClass(PostTeaser, [{
    key: "render",
    value: function render() {
      var _this = this;
      if (!this.transaction) {
        console.error('PostTeaser: transaction is required');
        return '';
      }
      var html = PostTeaserTemplate(this.app, this.mod, this.transaction, this.options);
      if (this.container) {
        var signature = this.transaction.signature || '';
        var selector = signature ? "".concat(this.container, " .post-teaser[data-tx-signature=\"").concat(signature, "\"]") : "".concat(this.container, " .post-teaser:last-child");
        if (document.querySelector(selector)) {
          this.app.browser.replaceElementBySelector(html, selector);
        } else {
          this.app.browser.addElementToSelector(html, this.container);
        }
        setTimeout(function () {
          _this.attachEvents();
        }, 25);
      }
      return html;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      // Click handling is managed by parent (ExploreOverlay / ViewPost)
    }
  }]);
}();
module.exports = PostTeaser;